/** Try/catch wrapper around sessionStorage for restricted environments (cross-origin iframes, Safari private mode). */
export const safeSessionStorage = {
    getItem(key: string): string | null {
        try {
            return window.sessionStorage.getItem(key);
        } catch {
            return null;
        }
    },
    setItem(key: string, value: string): void {
        try {
            window.sessionStorage.setItem(key, value);
        } catch {
            // sessionStorage unavailable or full
        }
    },
    removeItem(key: string): void {
        try {
            window.sessionStorage.removeItem(key);
        } catch {
            // sessionStorage unavailable
        }
    },
};

/** Read user traits from sessionStorage first, falling back to localStorage (where Segment writes directly when Proxy is unavailable). */
export const safeGetUserTraits = (key: string): string | null => {
    let value: string | null = null;

    try {
        value = window.sessionStorage.getItem(key);
    } catch {
        // sessionStorage unavailable
    }

    if (value !== null) {
        return value;
    }

    // Proxy not installed or sessionStorage empty — check localStorage
    // where Segment writes directly when Proxy is unavailable
    try {
        return window.localStorage.getItem(key);
    } catch {
        return null;
    }
};
